
import React, { Component } from 'react';

import './LoadingCircle.scss'

class LoadingCircle extends Component {
    render() {
        return (
            <div style={{
                display: "block",
                height: 47,
            }}>
                <div className="LoaderBoxCircle">
                    <div className="loader">
                        <svg className="circular" viewBox="25 25 50 50">
                            <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="3.5" strokeMiterlimit="10" />
                        </svg>
                    </div>
                </div>
            </div>

        );
    }
}

export default LoadingCircle;


// WEBPACK FOOTER //
// ./src/components/Loading/LoadingCircle.js